// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","453":"54292a4b","553":"f737e2f5","644":"65180d7d"}[chunkId] + ".chunk.js";
};